var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 125,
    viewBox: "0 0 1920 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 636.332 120.754)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 636.332 84.1239)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 636.332 36.877)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 598.705,
    y: 2.00012,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 598.705 2.00012)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 598.705,
    y: 38.6298,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 598.705 38.6298)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 598.705,
    y: 85.8768,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "rotate(90 598.705 85.8768)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 557.077 120.754)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 557.077 84.1239)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 557.077 36.877)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 519.449,
    y: 2.00012,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 519.449 2.00012)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 519.45,
    y: 38.6298,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 519.45 38.6298)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 519.45,
    y: 85.8768,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "rotate(90 519.45 85.8768)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 477.822 120.754)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 477.822 84.1239)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 477.822 36.877)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 440.194,
    y: 2.00012,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 440.194 2.00012)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 440.194,
    y: 38.6298,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 440.194 38.6298)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 440.194,
    y: 85.8768,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "rotate(90 440.194 85.8768)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 398.566 120.754)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 398.566 84.1239)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 398.566 36.877)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 360.938,
    y: 2.00012,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 360.938 2.00012)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 360.939,
    y: 38.6298,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 360.939 38.6298)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 360.939,
    y: 85.8768,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "rotate(90 360.939 85.8768)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 319.311 120.754)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 319.311 84.1239)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 319.311 36.8768)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 281.683,
    y: 2.00012,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 281.683 2.00012)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 281.684,
    y: 38.6298,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 281.684 38.6298)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 281.684,
    y: 85.8767,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "rotate(90 281.684 85.8767)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 240.056 120.754)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 240.056 84.1239)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 240.056 36.8768)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 202.428,
    y: 2.00012,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 202.428 2.00012)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 202.428,
    y: 38.6298,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 202.428 38.6298)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 202.428,
    y: 85.8767,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "rotate(90 202.428 85.8767)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 160.801 120.754)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 160.8 84.1239)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 160.8 36.8771)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 123.173,
    y: 2.00012,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 123.173 2.00012)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 123.173,
    y: 38.6298,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 123.173 38.6298)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 123.173,
    y: 85.8767,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "rotate(90 123.173 85.8767)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 81.5452 120.754)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 81.5452 84.1241)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 81.5452 36.877)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 43.9178,
    y: 2.00012,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 43.9178 2.00012)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 43.9178,
    y: 38.6298,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 43.9178 38.6298)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 43.9178,
    y: 85.8768,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "rotate(90 43.9178 85.8768)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1276.17 120.754)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1276.17 84.1239)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1276.17 36.877)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 1238.54,
    y: 2.00012,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 1238.54 2.00012)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 1238.54,
    y: 38.6298,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 1238.54 38.6298)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 1238.54,
    y: 85.8768,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "rotate(90 1238.54 85.8768)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1196.91 120.754)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1196.91 84.1239)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1196.91 36.877)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 1159.28,
    y: 2.00012,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 1159.28 2.00012)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 1159.28,
    y: 38.6298,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 1159.28 38.6298)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 1159.28,
    y: 85.8768,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "rotate(90 1159.28 85.8768)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1117.66 120.754)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1117.66 84.1239)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1117.66 36.877)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 1080.03,
    y: 2.00012,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 1080.03 2.00012)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 1080.03,
    y: 38.6298,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 1080.03 38.6298)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 1080.03,
    y: 85.8768,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "rotate(90 1080.03 85.8768)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1038.4 120.754)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1038.4 84.1239)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1038.4 36.877)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 1000.77,
    y: 2.00012,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 1000.77 2.00012)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 1000.77,
    y: 38.6298,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 1000.77 38.6298)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 1000.77,
    y: 85.8768,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "rotate(90 1000.77 85.8768)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 959.145 120.754)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 959.145 84.1239)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 959.145 36.8768)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 921.517,
    y: 2.00012,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 921.517 2.00012)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 921.517,
    y: 38.6298,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 921.517 38.6298)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 921.517,
    y: 85.8767,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "rotate(90 921.517 85.8767)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 879.89 120.754)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 879.89 84.1239)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 879.89 36.8768)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 842.262,
    y: 2.00012,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 842.262 2.00012)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 842.262,
    y: 38.6298,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 842.262 38.6298)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 842.262,
    y: 85.8767,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "rotate(90 842.262 85.8767)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 800.634 120.754)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 800.634 84.1239)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 800.634 36.8771)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 763.007,
    y: 2.00012,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 763.007 2.00012)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 763.007,
    y: 38.6298,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 763.007 38.6298)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 763.007,
    y: 85.8767,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "rotate(90 763.007 85.8767)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 721.379 120.754)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 721.379 84.1241)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 721.379 36.877)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 683.752,
    y: 2.00012,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 683.752 2.00012)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 683.752,
    y: 38.6298,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 683.752 38.6298)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 683.752,
    y: 85.8768,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "rotate(90 683.752 85.8768)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1916 120.754)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1916 84.1239)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1916 36.877)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 1878.37,
    y: 2.00012,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 1878.37 2.00012)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 1878.37,
    y: 38.6298,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 1878.37 38.6298)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 1878.37,
    y: 85.8768,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "rotate(90 1878.37 85.8768)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1836.74 120.754)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1836.74 84.1239)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1836.74 36.877)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 1799.12,
    y: 2.00012,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 1799.12 2.00012)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 1799.12,
    y: 38.6298,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 1799.12 38.6298)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 1799.12,
    y: 85.8768,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "rotate(90 1799.12 85.8768)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1757.49 120.754)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1757.49 84.1239)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1757.49 36.877)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 1719.86,
    y: 2.00012,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 1719.86 2.00012)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 1719.86,
    y: 38.6298,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 1719.86 38.6298)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 1719.86,
    y: 85.8768,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "rotate(90 1719.86 85.8768)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1678.23 120.754)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1678.23 84.1239)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1678.23 36.877)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 1640.61,
    y: 2.00012,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 1640.61 2.00012)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 1640.61,
    y: 38.6298,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 1640.61 38.6298)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 1640.61,
    y: 85.8768,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "rotate(90 1640.61 85.8768)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1598.98 120.754)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1598.98 84.1239)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1598.98 36.8768)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 1561.35,
    y: 2.00012,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 1561.35 2.00012)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 1561.35,
    y: 38.6298,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 1561.35 38.6298)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 1561.35,
    y: 85.8767,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "rotate(90 1561.35 85.8767)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1519.72 120.754)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1519.72 84.1239)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1519.72 36.8768)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 1482.1,
    y: 2.00012,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 1482.1 2.00012)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 1482.1,
    y: 38.6298,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 1482.1 38.6298)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 1482.1,
    y: 85.8767,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "rotate(90 1482.1 85.8767)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1440.47 120.754)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1440.47 84.1239)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1440.47 36.8771)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 1402.84,
    y: 2.00012,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 1402.84 2.00012)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 1402.84,
    y: 38.6298,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 1402.84 38.6298)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 1402.84,
    y: 85.8767,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "rotate(90 1402.84 85.8767)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1361.21 120.754)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1361.21 84.1241)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "matrix(-5.17926e-08 -1 -1 3.68911e-08 1361.21 36.877)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 1323.59,
    y: 2.00012,
    width: 120.753,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 1323.59 2.00012)",
    fill: "#29193E",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 1323.59,
    y: 38.6298,
    width: 84.1237,
    height: 41.9178,
    rx: 20.9589,
    transform: "rotate(90 1323.59 38.6298)",
    fill: "#8C74B7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 1323.59,
    y: 85.8768,
    width: 36.8767,
    height: 41.9178,
    rx: 18.4383,
    transform: "rotate(90 1323.59 85.8768)",
    fill: "#D8C1F7",
    stroke: "#29193E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorder);
export default __webpack_public_path__ + "static/media/Border.5dab158f7ca0e093059eff0e42672ff5.svg";
export { ForwardRef as ReactComponent };